import { RestApiClient } from 'ifield-core-components'

/**
 * ロール情報取得
 * @returns {Array.<Object>|Object} データ
 */
const getRoles = async () => {
  const url = RestApiClient.createApiUrl('user_role')
  const json = await RestApiClient.executeGetApi(url)
  return json.data
}

export default {
  namespaced: true,
  state: {
    roles: [],
  },
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.roles = []
    },
    /**
     * ロール情報を設定する
     * @param {*} state
     * @param {Array.<Object>} roles ロール情報
     */
    setRoles(state, roles) {
      state.roles = roles
    },
  },
  getters: {
    /**
     * ロール情報
     * @param {*} state
     * @returns {Array.<Object>}
     */
    roles: (state) => state.roles,
    /**
     * ロール情報(Map)
     * @param {*} state
     * @returns {Map}
     */
    roleMap: (state) => new Map(state.roles.map((role) => [role.id, role])),
    /**
     * 特定IDのロール情報を取得
     * @param {*} state
     * @param {*} getters
     * @returns {Function} IDを引数に特定IDのロール情報を返す関数
     */
    getRoleById: (state, getters) => (id) => getters.roleMap.get(id),
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * ロール情報を更新する
     */
    async updateRoles({ commit }) {
      const roles = await getRoles()
      commit('setRoles', roles)
    },
  },
}
